import { getBlogPostByTitle, getBlogPostsByIds, getBlogPostsInOrder } from '../Services/blog';
import { FetchBlogPostsParams } from '../Types/blog';
import { useBizQuery } from './useBizQuery';

const QUERYKEY_BLOGPOST_BY_TITLE = 'BLOGPOST_BY_TITLE';
const QUERYKEY_BLOGPOSTS_LIST = 'BLOGPOSTS_LIST';
const QUERYKEY_BLOGPOSTS_BY_IDS = 'BLOGPOSTS_BY_IDS';

export const useGetBlogPostByTitle = (title?: string) => {
	const enabled = !!title;
	const { data } = useBizQuery([QUERYKEY_BLOGPOST_BY_TITLE, title], () => getBlogPostByTitle(title ?? ''), enabled);
	return data ?? undefined;
};

export const useGetBlogPosts = (params: FetchBlogPostsParams, enabled = true) => {
	const { data } = useBizQuery([QUERYKEY_BLOGPOSTS_LIST, params], () => getBlogPostsInOrder(params), enabled);
	return data ?? undefined;
};

export const useGetBlogPostsByIds = (ids: number[], enabled = true) => {
	const normalizedIds = [...new Set(ids)].sort((a, b) => a - b);
	const { data, statusState } = useBizQuery(
		[QUERYKEY_BLOGPOSTS_BY_IDS, normalizedIds],
		() => getBlogPostsByIds(normalizedIds),
		enabled && normalizedIds.length > 0
	);

	return { blogPosts: data ?? [], statusState };
};
